import dayjs from "dayjs"

export function formatDateTime(
  time?: string,
  format: string = "YYYY-MM-DD HH:mm:ss"
) {
  return time ? dayjs(time).format(format) : "-"
}
